module.exports = __webpack_public_path__ + "img/voice-broadcast-green.19dcde0e.png";